import { writable } from 'svelte/store';
import  moment from 'moment';
const application={ firstName: " ",
middleName: "",
lastName: "",
dob: "",
gender: "",
relationship: "",
parentalResponsibility: "",
multipleBirth: "",
inCare: "",
hasEHCP: "",
address:"",
addressline1: "",
addressline2: "",
addressline3: "",
postTown: "",
postcode: "",
councilTaxNumber: "",
currentSchool: "",
scFirstName: "",
scLastName:"",
scRelationship: ""
}


export const Child = writable(null);

export const HelpSummary = writable([]);
export const InCareBoroughs = writable([]);
export const CurrentSchoolBoroughs = writable([]);
export const PreferenceSchoolBoroughs = writable([]);
export const ShowTooFewSchoolWarning = writable(true);
export const ShowTowerHamletQuestion = writable(true);

export const RelationshipOptions =[
    {"value":"PAM","label" : "Mother"},
    {"value":"PAF","label" : "Father"},
    {"value":"STM","label" : "Step Mother"},
    {"value":"STF","label" : "Step Father"},
    {"value":"FOM","label" : "Foster Mother"},
    {"value":"FOF","label" : "Foster Father"},
    {"value":"REL","label" : "Other Relative"},
    {"value":"SWR","label" : "Social Worker"},
    {"value":"OTH","label" : "Other Contact"},
    ]

export const ChildChunks = writable({});
export const DefaultChildChunks = writable({});

export const SelectedSchool = writable({})
export const dateToWords = (d)=>{   
    //const dt = new Date(d);  
    return  moment(d).format('Do MMMM YYYY');   
   //return dt.toLocaleString("default",{ year: 'numeric', month: 'long', day: 'numeric'});
  }